import { useEffect, useMemo } from 'react';
import { Components } from '@/schemas/sceneDataSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { FieldErrors, ResolverError, ResolverOptions, ResolverResult, useForm, UseFormReturn } from 'react-hook-form';
import { FormValues } from '@/constants/formTypes';
import { FormConfigResolver } from '@/schemas/formConfigResolver';
import { convertToFieldDateType } from '@/schemas/converters';
import { createErrorsFromServer } from '@/components/DynamicUI/createErrorsFromServer';

type ClientResolverResult = ResolverResult<FormValues, FormValues>;
type ClientResolverError = ResolverError<FormValues>;

function hasErrors(errors: ClientResolverResult['errors']): errors is ClientResolverError['errors'] {
  return Object.keys(errors).length !== 0;
}

function toErrors(errors: ClientResolverResult['errors'], exclude: string[] = []): FieldErrors<FormValues> {
  if (hasErrors(errors)) {
    return Object.fromEntries(
      Object.entries(errors).filter(([key]) => !exclude.includes(key))
    ) as FieldErrors<FormValues>;
  } else {
    return {};
  }
}

//..................................................................................................................................................................
//............................OOOOOOOOO.............................................................................................................................
//.DDDDDDDDDDDDDD...........OOOOOOOOOOOOO.......NNNNNN.......NNNNN..NNTTTTTTTTTTTTTTTT.......... EEEEEEEEEEEEEEEE...EDDDDDDDDDDDDDD......DIIIII.IIITTTTTTTTTTTTTTT..
//.DDDDDDDDDDDDDDDD........OOOOOOOOOOOOOOO......NNNNNNN......NNNNN..NNTTTTTTTTTTTTTTTT.......... EEEEEEEEEEEEEEEE...EDDDDDDDDDDDDDDD.....DIIIII.IIITTTTTTTTTTTTTTT..
//.DDDDDDDDDDDDDDDDD......OOOOOOOOOOOOOOOOO.....NNNNNNN......NNNNN..NNTTTTTTTTTTTTTTTT.......... EEEEEEEEEEEEEEEE...EDDDDDDDDDDDDDDDD....DIIIII.IIITTTTTTTTTTTTTTT..
//.DDDDDDDDDDDDDDDDDD....OOOOOOOOOOOOOOOOOOO....NNNNNNNN.....NNNNN..NNTTTTTTTTTTTTTTTT.......... EEEEEEEEEEEEEEEE...EDDDDDDDDDDDDDDDDD...DIIIII.IIITTTTTTTTTTTTTTT..
//.DDDDDDDDDDDDDDDDDD....OOOOOOOO...OOOOOOOO....NNNNNNNN.....NNNNN..NNTTTTTTTTTTTTTTTT.......... EEEEEEEEEEEEEEEE...EDDDDDDDDDDDDDDDDD...DIIIII.IIITTTTTTTTTTTTTTT..
//.DDDDD......DDDDDDD...DOOOOOOO......OOOOOOO...NNNNNNNNN....NNNNN........TTTTTT................ EEEEE..............EDDDDD......DDDDDDD..DIIIII........TTTTT........
//.DDDDD.......DDDDDDD..DOOOOOO.......OOOOOOO...NNNNNNNNNN...NNNNN........TTTTTT................ EEEEE..............EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO.........OOOOOO...NNNNNNNNNN...NNNNN........TTTTTT................ EEEEE..............EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO.........OOOOOO...NNNNNNNNNNN..NNNNN........TTTTTT................ EEEEEEEEEEEEEEE....EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO..........OOOOOO..NNNNNNNNNNN..NNNNN........TTTTTT................ EEEEEEEEEEEEEEE....EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO..........OOOOOO..NNNNN.NNNNNN.NNNNN........TTTTTT................ EEEEEEEEEEEEEEE....EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOO...........OOOOOO..NNNNN.NNNNNN.NNNNN........TTTTTT................ EEEEEEEEEEEEEEE....EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO..........OOOOOO..NNNNN..NNNNNNNNNNN........TTTTTT................ EEEEEEEEEEEEEEE....EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD........DDDDDD..DOOOOO.........OOOOOO...NNNNN..NNNNNNNNNNN........TTTTTT................ EEEEE..............EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD.......DDDDDDD..DOOOOO.........OOOOOO...NNNNN...NNNNNNNNNN........TTTTTT................ EEEEE..............EDDDDD.......DDDDDD..DIIIII........TTTTT........
//.DDDDD.......DDDDDDD..DOOOOOO.......OOOOOOO...NNNNN....NNNNNNNNN........TTTTTT................ EEEEE..............EDDDDD......DDDDDDD..DIIIII........TTTTT........
//.DDDDD......DDDDDDD...DOOOOOOO......OOOOOOO...NNNNN....NNNNNNNNN........TTTTTT................ EEEEE..............EDDDDD.....DDDDDDD...DIIIII........TTTTT........
//.DDDDDDDDDDDDDDDDDD....OOOOOOOO...OOOOOOOO....NNNNN.....NNNNNNNN........TTTTTT................ EEEEEEEEEEEEEEEEE..EDDDDDDDDDDDDDDDDD...DIIIII........TTTTT........
//.DDDDDDDDDDDDDDDDD.....OOOOOOOOOOOOOOOOOOO....NNNNN.....NNNNNNNN........TTTTTT................ EEEEEEEEEEEEEEEEE..EDDDDDDDDDDDDDDDDD...DIIIII........TTTTT........
//.DDDDDDDDDDDDDDDDD......OOOOOOOOOOOOOOOOO.....NNNNN......NNNNNNN........TTTTTT................ EEEEEEEEEEEEEEEEE..EDDDDDDDDDDDDDDDD....DIIIII........TTTTT........
//.DDDDDDDDDDDDDDDD........OOOOOOOOOOOOOOO......NNNNN......NNNNNNN........TTTTTT................ EEEEEEEEEEEEEEEEE..EDDDDDDDDDDDDDDD.....DIIIII........TTTTT........
//.DDDDDDDDDDDDDD...........OOOOOOOOOOOOO.......NNNNN.......NNNNNN........TTTTTT................ EEEEEEEEEEEEEEEEE..EDDDDDDDDDDDDDD......DIIIII........TTTTT........
//............................OOOOOOOOO.............................................................................................................................
//..................................................................................................................................................................

/**
 * This file is extremely critical if you're trying to fix a bug almost
 * certainly the issue is elsewhere. This file effects all steps / scenes in
 * hostedX in all experiences
 * @param components List of all components
 * @param param1 option parameters
 * @returns useReactForm Form
 */
export default function useDynamicForm(
  components: Components,
  {
    validateOnMount = false,
    validationMode,
  }: { validateOnMount?: boolean; validationMode?: 'onSubmit' | 'onChange' } = {}
): UseFormReturn<FormValues, unknown, FormValues> {
  const formResolver = useMemo(() => new FormConfigResolver(components), [components]);

  const schema = useMemo(() => formResolver.formSchema(), [formResolver]);
  const defaultValues = useMemo(() => formResolver.defaultValues(), [formResolver]);
  const maskedFields = useMemo(() => formResolver.maskedFields(), [formResolver]);
  const serverErrors = useMemo(() => formResolver.invalidFields(), [formResolver]);
  const fields = useMemo(() => formResolver.inputFields, [formResolver]);

  const baseResolver = zodResolver(schema);

  const resolver = async (
    values: FormValues,
    context: unknown,
    options: ResolverOptions<FormValues>
  ): Promise<ClientResolverResult> => {
    // Find the server errors that have not changed
    const unchangedServerErrors = serverErrors.filter((field) => values[field.key] === defaultValues[field.key]);

    // Find the masked fields that have not changed
    const unchangedMaskedFields = maskedFields.filter((field) => values[field] === defaultValues[field]);

    // This handles some of nuance of how values are stored in
    // html inputs and converts them to the desired type
    const convertedValues = convertToFieldDateType(values, fields);
    const result: ClientResolverResult = await baseResolver(convertedValues, context, options);

    // Here we want to ignore server error for unchanged values
    // And ignore client errors that are masked. Both of these are
    // eventually ignored by the system downstream
    const formattedServerErrors = createErrorsFromServer(unchangedServerErrors, options.fields);
    const filteredClientErrors = toErrors(result.errors, unchangedMaskedFields);

    if (hasErrors(formattedServerErrors) || hasErrors(filteredClientErrors)) {
      const errors: FieldErrors<FormValues> = {
        ...toErrors(formattedServerErrors),
        ...filteredClientErrors,
      };

      // failure case we encountered an error on the client
      // or the server
      return {
        errors,
        values: {},
      };
    } else {
      // success case we shouldn't have errors
      return {
        values: convertedValues,
        errors: {},
      };
    }
  };

  const form = useForm({
    defaultValues,
    resolver,
    shouldUnregister: true,
    // Explicit validation_mode from server wins; otherwise validate_on_mount
    // forms default to onChange so errors clear as the user fills fields,
    // and other forms keep onSubmit (errors only show after submit).
    mode: validationMode ?? (validateOnMount ? 'onChange' : 'onSubmit'),
  });

  useEffect(() => {
    if (validateOnMount || serverErrors.length > 0) {
      void form.trigger();
    }
  }, [form, serverErrors, validateOnMount, validationMode]);

  return form;
}
